import { createClient } from '@supabase/supabase-js';

export const SUPABASE_URL = 'https://qnwokktdgpqilaooanfe.supabase.co';

export const supabase = createClient(
  SUPABASE_URL,
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InFud29ra3RkZ3BxaWxhb29hbmZlIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODA3NjEyMzgsImV4cCI6MjA5NjMzNzIzOH0.c-DrRitewcaG4n3EYg5SIJ5Gh3DDgSKbNYRvnpq7Ex0'
);